import { useNavigate } from 'react-router-dom';
import { useGlobalModals } from 'src/contexts/global-modals';
import { links } from 'src/router/routes';

export const useCampaignDetails = (campaignId: number) => {
  const { openDeleteCampaignModal } = useGlobalModals();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`${links.campaigns}`);
  };

  const handleEdit = () => {
    navigate(`${links.campaignEdit}/${campaignId}/edit`);
  };

  const handleDelete = () => {
    openDeleteCampaignModal(campaignId);
  };

  return {
    handleEdit,
    handleDelete,
    handleCancel,
  };
};
